import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, message } from 'antd';
import { IoMdAdd } from 'react-icons/io';
import axios from 'axios';

const AddCourtDetails = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [court, setCourt] = useState([]);

  const handleSubmit = async values => {
    setLoading(true);
    /* try {
      const response = await axios.post(
        'http://admin.defconinnovations.com/advocateapi/courts/',
        {
          name: values.name,
          location: values.location,
        },
        {
          headers: {
            Authorization: `Token c404c955a08ca1779628c914e7692927074af875`,
          },
        }
      );
      message.success('Court added successfully');
      console.log('Response data:', response.data);
      setOpen(false);
      form.resetFields();
    } catch (error) {
      console.error(
        'Error posting Court:',
        error.response?.data || error.message
      );
      message.error(
        'Failed to add court: ' +
          (error.response?.data?.location?.[0] || 'Unknown error')
      );
    } finally {
      setLoading(false);
    } */
  };

  const fetchCourt = async () => {
    try {
      const response = await axios.get(
        'http://admin.defconinnovations.com/advocateapi/courts/',
        {
          headers: {
            Authorization: 'Token c404c955a08ca1779628c914e7692927074af875',
          },
        }
      );
      setCourt(response.data);
    } catch (error) {
      /* console.log('Error fetching courts:', error); */
    }
  };
  useEffect(() => {
    /* fetchCourt(); */
  }, []);

  return (
    <>
      <Button icon={<IoMdAdd />} type="primary" onClick={() => setOpen(true)}>
        Add Court
      </Button>
      <Modal
        open={open}
        title="Add Court" // Fixed the modal title
        onCancel={() => setOpen(false)}
        onOk={() => form.submit()}
        okText="Submit"
        confirmLoading={loading}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          name="add_court_form"
          onFinish={handleSubmit}
          preserve={false}
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[
              {
                required: true,
                message: 'Please enter the name of the court',
              },
            ]}
          >
            <Input type="text" placeholder="Enter Court Name" />
          </Form.Item>
          <Form.Item
            name="location" // Changed from "Location" to "location"
            label="Location"
            rules={[
              {
                required: true,
                message: 'Please enter the location',
              },
            ]}
          >
            <Input type="text" placeholder="Enter Your Location" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddCourtDetails;
